import {FC} from 'react';
//mui
import {Box} from '@mui/material';
//components
import Button from '@/shared/components/Button';
//constants
import {OUTLINE, PRIMARY} from '@/utils/constants';
//styles
import {tableFooterActionsStyle} from './TableFooterActions.styles';

interface TableFooterActionsProps {
	titleButtonPrev: string;
	titleButtonNext: string;
	onClickButtonPrev?: () => void;
	onClickButtonNext: () => void;
	disabledButtonPrev?: boolean;
	disabledButtonNext?: boolean;
}

const TableFooterActions: FC<TableFooterActionsProps> = ({
	titleButtonPrev,
	titleButtonNext,
	disabledButtonPrev,
	disabledButtonNext,
	onClickButtonPrev,
	onClickButtonNext,
}) => {
	return (
		<Box sx={tableFooterActionsStyle.wrapper}>
			<Button
				title={titleButtonPrev}
				sx={tableFooterActionsStyle.button}
				onClick={onClickButtonPrev}
				variant={OUTLINE}
				color={PRIMARY}
				disableRipple
				disabled={disabledButtonPrev}
			/>

			<Button
				title={titleButtonNext}
				sx={tableFooterActionsStyle.button}
				onClick={onClickButtonNext}
				disableRipple
				disabled={disabledButtonNext}
			/>
		</Box>
	);
};

export default TableFooterActions;
